/**
 * Mapping des domaines d'obligations (§15.D / EPIC-030, +`personal`
 * §19.C EPIC-054.5) vers leur classe pill + libellé d'affichage.
 * Partagé par `upcoming_obligations_block_controller.js` (30.4) et
 * `upcoming_obligations_page_controller.js` (30.5).
 *
 * Les classes pill sont alignées sur le mapping figé par 30.1
 * (rapport de gate maquettes — section « Mapping pills final »).
 * `personal` réutilise la pill `--olive` (cohérent avec `acre` —
 * accompagnement personnel par opposition aux obligations système-driven).
 */

export const DOMAIN_PILL_MAP = {
    urssaf:         { class: "nm-pill nm-pill--blue",   label: "urssaf" },
    acre:           { class: "nm-pill nm-pill--olive",  label: "acre" },
    france_travail: { class: "nm-pill nm-pill--blue",   label: "france travail" },
    arce:           { class: "nm-pill nm-pill--red",    label: "arce" },
    vl:             { class: "nm-pill",                 label: "versement libératoire" },
    tva:            { class: "nm-pill nm-pill--ochre",  label: "tva" },
    das2:           { class: "nm-pill",                 label: "das2" },
    cfe:            { class: "nm-pill nm-pill--ochre",  label: "cfe" },
    ir:             { class: "nm-pill nm-pill--indigo", label: "impôts" },
    comptabilite:   { class: "nm-pill",                 label: "comptabilité" },
    abonnement:     { class: "nm-pill nm-pill--indigo", label: "abonnement" },
    assurances:     { class: "nm-pill nm-pill--blue",   label: "assurance" },
    personal:       { class: "nm-pill nm-pill--olive",  label: "personnel" },
};

export function getDomainPill(domain) {
    return DOMAIN_PILL_MAP[domain] ?? { class: "nm-pill", label: domain ?? "" };
}
